import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button
} from '@mui/material';
import { useForm } from 'react-hook-form';

import MutateCustomerCategoryDialogProps from './MutateCustomerCategoryDialogProps';

const MutateCustomerCategoryDialog = ({
  customerCategory,
  onCancel,
  onSubmit
}: MutateCustomerCategoryDialogProps) => {
  const defaultValues = {
    name: customerCategory?.name || '',
    description: customerCategory?.description || ''
  };

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({ defaultValues });

  return (
    <Dialog open>
      <DialogTitle>
        {customerCategory ? 'Edit Customer Category' : 'Add Customer Category'}
      </DialogTitle>
      <DialogContent>
        <TextField
          label='Name'
          type='text'
          margin='dense'
          helperText={errors.name ? 'Field is required.' : ''}
          error={!!errors.name}
          fullWidth
          autoFocus
          {...register('name', { required: true })}
        />
        <TextField
          label='Description'
          type='text'
          margin='dense'
          fullWidth
          {...register('description')}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          onClick={handleSubmit((fields) => {
            onSubmit({ id: customerCategory?.id, ...fields });
          })}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MutateCustomerCategoryDialog;
